/**
 * @deprecated
 * This component has been deprecated. `LogoBarV2` should be used instead.
 */
export const logoBarConfig = {
    name: 'LogoBar',
    hideFromInsertMenu: true,
    image: 'https://cdn.zapier.com/storage/photos/f9503143fb1b1eaf4dcd839a06ffc9aa.png',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: 'Trusted at companies large and small',
            required: true,
        },
        {
            name: 'items',
            type: 'list',
            defaultValue: [],
            subFields: [
                {
                    name: 'logoUrl',
                    type: 'cloudinaryImage',
                    defaultValue: 'https://cdn.zappy.app/dd2c451262bf37375ce17fedcbaa2d17.svg',
                },
                {
                    name: 'companyName',
                    type: 'string',
                    helperText: 'Used for alt text for the company logo',
                    required: true,
                },
                {
                    name: 'height',
                    type: 'number',
                },
                {
                    name: 'width',
                    type: 'number',
                },
            ],
        },
    ],
};
//# sourceMappingURL=config.js.map